import $ from "jquery";
import PageBase from "./PageBase";


export default class VisualApp extends PageBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    $("#js-triggerElements1").addClass("hide");
    $("#js-triggerElements2").addClass("hide");

    this.initFadeAnimation();

    this.slideMaxList = [];
    this.slideMax = 0;
    this.isShow = false;
    this.isTransitionunning = false;
    this.slideIndex = 0;
    this.$detail = $("#js-detail");
    this.$detailContentsList = this.$detail.find(".detailContents");
    this.$detailContentsList.hide();
    this.$detailContentsList.addClass("hide");
    this.$prevButton = $("#js-prevButton");
    this.$nextButton = $("#js-nextButton");
    this.$closeButton = $("#js-closeButton");
    this.$detailContentsList.each((index, el) => {
      this.slideMaxList.push($(el).data("max"));
    });

    this.$closeButton.click(() => {
      this.closeSlide();
    });

    this.$prevButton.click(() => {
      this.slideIndex--;

      if (this.slideIndex < 0) {
        this.slideIndex = this.slideMax - 1;
      }

      this.setSlide(this.slideIndex);
    });

    this.$nextButton.click(() => {
      this.slideIndex++;

      if (this.slideIndex >= this.slideMax) {
        this.slideIndex = 0;
      }

      this.setSlide(this.slideIndex);
    });

    window.onhashchange = () => {
      this.handleHasnChange();
    };

    this.handleHasnChange();
  }

  closeSlide() {
    this.$detail.fadeOut(400);
    location.hash = "";
    $(window).scrollTop(this.scrollTop);
    $("html").css({"overflow-y": "auto"});

    if (this.$currentContents) {
      this.$currentContents.removeClass("show");
      this.$currentContents.addClass("hide");
    }

    setTimeout(() => {
      if (this.$currentContents) {
        this.$currentContents.hide();
      }
    }, 500);
  }

  handleHasnChange() {
    let hash = location.hash.length <= 0 ? null : location.hash;
    this.$detailContentsList.hide();
    this.$detailContentsList.addClass("hide");

    if (hash) {
      if (/#detail/.test(hash)) {
        const array = hash.split("/");
        const id = parseInt(array[0].replace("#detail", ""));
        this.slideMax = this.slideMaxList[id - 1];

        if (array.length > 1 && array[1]) {
          const page = parseInt(array[1]);
          let anchor = null;

          if (array[2]) {
            anchor = `#${id}-${page}-${array[2]}`;
          }

          this.setContent(id, page, anchor);
        } else {
          this.setContent(id);
        }
      }
    } else {
      this.closeSlide();
    }
  }

  setContent(id, page = 1, anchor=null) {
    this.scrollTop = $(window).scrollTop();
    this.isTransitionunning = false;
    // $("html").addClass("scrollDisabled");
    $("html").css({"overflow-y": "hidden"});
    this.$detail.fadeIn(600);

    const $contents = $(`#js-detailContents${id}`);
    $contents.removeClass("hide");
    $contents.addClass("show");
    $contents.show();
    this.$currentContents = $contents;

    const $contentsBodys = $contents.find(".detailContents__body");
    $contentsBodys.removeClass("show");
    $contentsBodys.addClass("hide");
    this.$currentContentsBodys = $contentsBodys;

    // this.$currentContents = $contents;
    this.isShow = true;
    this.slideIndex = page - 1;

    console.log("[setSlide]", "id:", id, "slideIndex:", this.slideIndex);
    this.setSlide(this.slideIndex, anchor);
  }

  setSlide(index, anchor=null) {
    if (this.isTransitionunning) {
      return;
    }

    const el = this.$currentContentsBodys[index];
    this.isTransitionunning = true;
    $(el).show();

    if (this.$currentSlide) {
      this.$currentSlide.removeClass("show");
      this.$currentSlide.addClass("hide");

      setTimeout(() => {
        // this.$currentSlide.hide();
        this.$currentSlide = $(el);
        this.showSlide($(el), anchor);
      }, 200);
    } else {
      this.showSlide($(el), anchor);
      this.$currentSlide = $(el);
    }
  }

  showSlide($el, anchor=null) {
    // $el.show();
    $el.removeClass("hide");
    $el.addClass("show");

    if (anchor) {
      const $target = $(anchor);
      const top = $target.offset().top;
      $("#js-detail").animate({scrollTop: top}, top * 0.4, "swing");
    }

    setTimeout(() => {
      this.isTransitionunning = false;
    }, 400);
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/VisualApp.js